/**
 * @generated SignedSource<<8b635590a6ce8ddda368bc74372eee6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetEntrypointHeadlineContent$data = {
  readonly entityId: string;
  readonly seriesContainer: {
    readonly entityId: string;
    readonly headline: string | null;
    readonly series: ReadonlyArray<{
      readonly entityId?: string;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null;
  readonly " $fragmentType": "seriesWidgetEntrypointHeadlineContent";
};
export type seriesWidgetEntrypointHeadlineContent$key = {
  readonly " $data"?: seriesWidgetEntrypointHeadlineContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetEntrypointHeadlineContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetEntrypointHeadlineContent",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "series",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "Article",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "db119b6bd41bfa0f983f073d86c02a4e";

export default node;
